import React from 'react';

function Form({ children, className, noValidate }) {
  return (
    <form
      noValidate={noValidate}
      className={className}
    >
      {children}
    </form>
  );
}

export default Form;
